import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportService {

  readonly rootUrl = environment.baseUrl;
  constructor(private http: HttpClient) { }

  getHrOrderReport(datefrom, dateto)
  {
    const daterange = {
      dateFrom: datefrom,
      dateTo : dateto
    }
    return this.http.post(this.rootUrl + '/api/Reports/GetHrOrderUploadReport', daterange);
  }

  getFilledOrderReport()
  {
    return this.http.get(this.rootUrl + '/api/Reports/GetFilledOrderReport');
  }

  getFilledOrderReportUrl()
  {
    return this.http.get(this.rootUrl + '/api/Reports/GetFilledOrderUrl');
  }

  getHrOrderReportUrl()
  {
    return this.http.get(this.rootUrl + '/api/Reports/GetHrOrderUrl');
  }

}
